var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCourseManagement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.986,
    height: 47.951,
    viewBox: "0 0 35.986 47.951",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "document",
    transform: "translate(-845.947 -335.131)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M936.586,508.551H900.6V460.6h35.986ZM918.488,481h10.888c1.436,0,2.243-.658,2.243-1.795,0-1.107-.837-1.795-2.243-1.795H907.839c-1.406,0-2.243.688-2.243,1.795,0,1.137.807,1.795,2.243,1.795Zm.12,7.419h10.769c1.436,0,2.243-.658,2.243-1.795,0-1.107-.837-1.795-2.243-1.795H907.839c-1.406,0-2.243.688-2.243,1.795,0,1.137.807,1.795,2.243,1.795Zm-.03,7.389h10.769c1.436,0,2.244-.658,2.244-1.795,0-1.107-.838-1.795-2.244-1.795H907.809c-1.406,0-2.244.688-2.244,1.795s.808,1.795,2.244,1.795Zm.06,3.829H907.659a1.816,1.816,0,0,0-2.063,1.735,1.786,1.786,0,0,0,1.974,1.825c7.358,0,14.717.03,22.106-.03a2.492,2.492,0,0,0,1.675-.867c.867-1.2-.15-2.662-1.795-2.662C925.877,499.607,922.257,499.637,918.638,499.637Zm-.06-33.712H907.809c-1.436,0-2.244.658-2.244,1.795,0,1.107.837,1.795,2.244,1.795h21.538c1.406,0,2.244-.688,2.244-1.795s-.808-1.795-2.244-1.795Z",
    transform: "translate(-54.654 -125.469)",
    fill: "#cf2856"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseManagement);
export default __webpack_public_path__ + "static/media/course_management.d0e671d51a4cf67b0634f8b85bdaf49f.svg";
export { ForwardRef as ReactComponent };